import { Box, Checkbox, Text } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, some } from 'lodash';
import React from 'react';
import { planStatusList } from '../drawer-state';
import { ListSelectionStyled } from '../styled';
export const PlanStatusList: React.FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();
  return (
    <Box data-testid="success" flexDirection={{ sm: 'column' }}>
      <ListSelectionStyled
        isSubItem={true}
        onClick={() => {
          if (form.values.filterByPlanStatusTypes?.length !== planStatusList.length) {
            form.setFieldValue('filterByPlanStatusTypes', planStatusList);
          } else {
            form.setFieldValue('filterByPlanStatusTypes', []);
          }
        }}
      >
        <Box alignItems={{ sm: 'center' }}>
          <Box mr={{ sm: '500' }}>
            <Checkbox
              checked={form.values.filterByPlanStatusTypes?.length === planStatusList.length}
              readOnly
              indeterminate={
                form.values.filterByPlanStatusTypes?.length > 0 &&
                form.values.filterByPlanStatusTypes?.length < planStatusList.length
              }
            />
          </Box>
          <Text size="400" weight="600" color="bechtel.grey.1000">
            <Trans>Plan Status</Trans>
          </Text>
        </Box>
        {form.values.filterByPlanStatusTypes && form.values.filterByPlanStatusTypes.length > 0 && (
          <Text size="400" color="bechtel.grey.1000">
            {form.values.filterByPlanStatusTypes.length} <Trans>Selected</Trans>
          </Text>
        )}
      </ListSelectionStyled>
      <FieldArray name="filterByPlanStatusTypes">
        {(arrayHelpers) => {
          return (
            <>
              {planStatusList &&
                planStatusList.map((planStatusType) => {
                  return (
                    <ListSelectionStyled
                      key={planStatusType.id}
                      onClick={() => {
                        const selected = findIndex(form.values.filterByPlanStatusTypes, (item: any) => {
                          return item.id === planStatusType.id;
                        });
                        if (selected !== -1) {
                          arrayHelpers.remove(selected);
                        } else {
                          arrayHelpers.push(planStatusType);
                        }
                      }}
                      data-testid="plan-status-type-list-item"
                    >
                      <Box mr={{ sm: '500' }}>
                        <Checkbox
                          checked={some(form.values.filterByPlanStatusTypes, (item) => {
                            return item.id === planStatusType.id;
                          })}
                          readOnly
                        />
                      </Box>
                      <Text size="400" color="bechtel.grey.1000" data-testid="plan-status-type-item-label">
                        {i18n._(planStatusType.label)}
                      </Text>
                    </ListSelectionStyled>
                  );
                })}
            </>
          );
        }}
      </FieldArray>
    </Box>
  );
};
